export interface EventItem {
  id: string;
  title: string;
  categoryLabel: string;
  person: string;
  date: string;
  heat: string;
  read: string;
  excerpt: string;
  tags: string[];
  content: string[];
}

export const events: EventItem[] = [
  {
    id: "guitar-boy-chengdu",
    title: "素人吉他少年街头翻唱意外爆红：一首老歌引发的出圈",
    categoryLabel: "才艺",
    person: "吉他手阿澈",
    date: "2026-09-05",
    heat: "1280万",
    read: "6分钟",
    excerpt: "没有包装、没有声卡，成都街头一把旧吉他唱哭路人。这场“路人视角”的出圈，藏着一条可以复盘的素人走红路径。",
    tags: ["街头翻唱", "素人出圈", "内容复盘"],
    content: [
      "那晚的成都街头并不特殊，只有一个男孩、一把旧吉他，和一段路过的围观人群。直到有人把几十秒的现场视频发上社交平台，一切开始不一样。",
      "视频里没有精致的打光，也没有预设的机位，画面甚至有些晃动。可正是这份“未经加工”的真实，击中了见惯了包装的观众——大家很久没有为一段不修音的歌喉停下来过了。",
      "当晚，视频以惊人的速度在多个平台扩散。人们讨论的不只是歌声本身，还有年轻人面对镜头时的松弛与坦然。这种“素人感”反而成为他最大的辨识度。",
      "复盘这场走红会发现：真实场景、情感共鸣和“路人第一视角”三者叠加，往往比刻意制作的精致内容更容易被快速转发。这正是当下素人出圈屡屡奏效的底层逻辑。",
    ],
  },
  {
    id: "potter-homecoming",
    title: "辞职返乡做土陶的90后：一条手作视频让老手艺重新发光",
    categoryLabel: "手作非遗",
    person: "返乡陶娘·陶小满",
    date: "2026-09-03",
    heat: "960万",
    read: "5分钟",
    excerpt: "从写字楼回到窑火边，她把手作日常拍成安静短片。慢下来的节奏，成了城市年轻人最想看的“反内卷”内容。",
    tags: ["返乡", "陶艺", "非遗年轻化"],
    content: [
      "离开大厂的那天，陶小满在工位上删光了所有待办事项。她回到景德镇，接过了家里落了灰的拉坯机，也接过了一段关于手艺和时间的慢生活。",
      "她的视频没有旁白，只有揉泥、拉坯、修坯、上釉的安静画面。泥土在掌心旋转的声音、窑火燃烧的噼啪声，成了她评论区里最常被提到的“治愈白噪音”。",
      "让老手艺获得新流量，靠的不是悲情叙事，而是手艺本身经得起凝视的美感。当年轻人愿意为一双手停下手里的快进键，非遗年轻化就真正开始了。",
      "如今每晚开窑都像一场小小的仪式。她把出窑的每件器物都记录成档案，也把“手艺如何被看见”这个时代的命题，讲给更多人听。",
    ],
  },
  {
    id: "county-barber",
    title: "县城理发师的“手艺秀”：普通Tony老师如何变成百万粉主角",
    categoryLabel: "职业达人",
    person: "大橙Tony",
    date: "2026-08-30",
    heat: "880万",
    read: "4分钟",
    excerpt: "没有网红店加持，几十年练就的剪发绝活自带流量。当技术成为内容，小人物也能站上聚光灯。",
    tags: ["手艺内容", "职业叙事", "小镇青年"],
    content: [
      "大橙Tony的店开在县城一条不算热闹的街角，招牌朴实，座位不多。真正让他出圈的，是那把被他用了几十年、磨得发亮的剪刀。",
      "他把自己接待客人的过程拍成几十秒的短片：理发、修剪、造型，一气呵成。没有脚本和夸张反应，剪完之后客人的那声“哇”，就是最好的内容高潮。",
      "网友笑称他是“被县城耽误的托尼天花板”，但他更在意的是，一门手艺如何被认真对待。这种对职业的专注与体面，正是内容里最打动人、也最难复制的东西。",
      "技术型内容自带说服力：观众会为肉眼可见的“功力”买单。当许多账号还在比拼话术与颜值时，他把注意力放回了那双稳准的手上，反而赢得了更长久的喜爱。",
    ],
  },
  {
    id: "catcafe-healing",
    title: "猫咖店员与毛孩子的治愈日常：一条慢视频冲上热榜",
    categoryLabel: "萌宠治愈",
    person: "奶糖酱",
    date: "2026-08-26",
    heat: "1120万",
    read: "4分钟",
    excerpt: "不打广告不煽情，她只记录小猫打盹和蹭手的小瞬间。疲惫的年轻人，正需要这样一个情绪出口。",
    tags: ["萌宠", "情绪价值", "慢生活"],
    content: [
      "在厦门那家不大的猫咖里，奶糖酱的一天从给小猫们添水、换猫砂开始。她的镜头很稳，从不刻意摆拍，只是安静地记录与毛孩子相处的每个细节。",
      "小猫伸懒腰时颤动的耳朵、午睡时均匀起伏的肚皮、凑过来蹭她手心的温热触感……这些稀松平常的瞬间，被她拍得温柔又具体，仿佛能隔着屏幕传递温度。",
      "评论区里最常见的留言是“看哭了”和“谢谢”。在节奏飞快的生活里，一段治愈系内容提供的不仅是消遣，更是一种被允许慢下来的情绪许可。",
      "这类内容走红的启示在于：年轻人追逐的从不是热闹本身，而是被真实温柔以待的体验。真实、克制、有温度，比任何精心设计的“剧情”都更能抵达人心。",
    ],
  },
  {
    id: "shadow-puppet-live",
    title: "非遗皮影戏搬进直播间：年轻一代让老手艺重新亮起来",
    categoryLabel: "手作非遗",
    person: "皮影少年·阿辛",
    date: "2026-08-22",
    heat: "760万",
    read: "5分钟",
    excerpt: "幕布后一盏灯，直播间两万人在线。他用年轻人听得懂的方式，讲活了渐被遗忘的老手艺。",
    tags: ["皮影戏", "直播", "传统文化"],
    content: [
      "阿辛的皮影戏台不大，一束光、一块白幕、几件刻了三个月的皮影。每晚开播，他先把幕布后的世界点亮，再开始今晚的故事。",
      "为了让年轻人看得进去，他重新编排了经典桥段，把网络热梗和现代生活悄悄织进唱词里。古老唱腔与现代表达相遇，竟毫无违和感。",
      "直播让这门手艺有了新的观众：有的观众一连守了好几晚，只为看他给新刻的皮影上色；也有年轻人留言说要来学刻影，这是最让阿辛意外也最欣慰的回应。",
      "传统文化真正“火起来”，靠的是有人愿意俯下身去讲、去演、去等待。当古老的技艺遇见现代的观看方式，它没有过时，只是换了一种被看见的姿势。",
    ],
  },
  {
    id: "open-mic-explosion",
    title: "第一次上台就炸场：素人脱口秀演员用生活段子圈粉百万",
    categoryLabel: "表达",
    person: "话痨小北",
    date: "2026-08-18",
    heat: "1040万",
    read: "5分钟",
    excerpt: "没有专业团队，他讲早高峰、租房、点外卖的日常。让人又笑又共鸣的表达，正成为新的流量风口。",
    tags: ["脱口秀", "素人", "情绪共鸣"],
    content: [
      "上台前五分钟，话痨小北还在后台来回踱步。作为第一次站上开放麦舞台的素人，他没想到自己讲完的瞬间，台下会响起几乎掀翻屋顶的掌声。",
      "他的段子不炫技，讲的都是大家每天都会遇到的事：挤早高峰地铁被挤到怀疑人生、租房被房东套路、深夜点外卖却迟迟等不来。越普通，越让人会心一笑。",
      "观众笑完之后常常愣一下——那些被调侃的窘迫，原来都是自己的日常。表达能戳中情绪，往往比单纯制造笑点更高级，也更能形成持久的记忆点。",
      "从开放麦到百万关注，小北证明了“真实生活是最好的剧本”。当表达者愿意把自己的狼狈讲得真诚又好笑，共鸣就会替他完成剩下的传播。",
    ],
  },
];

export const hotRankIds = [
  "guitar-boy-chengdu",
  "catcafe-healing",
  "open-mic-explosion",
  "potter-homecoming",
  "county-barber",
  "shadow-puppet-live",
];

export const faqs = [
  {
    q: "“吃瓜爆网”主要追踪哪些内容？",
    a: "我们专注于新晋网红与爆红人物的走红事件追踪，包括素人出圈路径、热门主角档案、爆红人物盘点与走红过程复盘，帮助读者看懂一个个从素人到顶流的故事背后的规律。",
  },
  {
    q: "平台上的人物和事件内容如何保证客观？",
    a: "我们的编辑会多方核对可公开的信息来源，尽量还原走红事件的真实脉络。对于仍在变化中的热点，我们标注追踪状态并及时更新，避免把未经证实的内容当成既定事实。",
  },
  {
    q: "内容多久更新一次？",
    a: "走红事件与热榜信息会跟随热点实时滚动更新，人物档案与深度复盘类内容则每周定期打磨上新，确保你在追更时总能读到新鲜且有价值的内容。",
  },
  {
    q: "能否在这里投稿自己发现的热门主角或走红事件？",
    a: "非常欢迎。你可以通过“联系我们”提交线索，若线索真实、有可追溯来源且符合栏目定位，编辑会评估后跟进报道并注明提供者。",
  },
  {
    q: "订阅资讯能获得什么？",
    a: "订阅后，我们会定期把精选的走红事件、热门主角档案与热点复盘推送给你，帮助你不错过每一次重要的出圈节点。",
  },
];

export const hotTypes = [
  {
    key: "caiyi",
    label: "才艺破圈",
    desc: "歌唱、舞蹈、乐器……用看得见的硬实力，在最短时间内完成路人到主角的身份切换。",
  },
  {
    key: "shouyi",
    label: "手作与非遗",
    desc: "一门手艺被认真凝视的时刻。返乡与传承，让老技艺在新镜头里重新被年轻人喜欢。",
  },
  {
    key: "zhiye",
    label: "职业叙事",
    desc: "把普通职业做到极致，专注本身即是内容。小镇与技能，正在成为新的流量主场。",
  },
  {
    key: "mengchong",
    label: "萌宠与治愈",
    desc: "提供情绪价值的轻内容。真实、克制、有温度，让疲惫的人找到一个柔软出口。",
  },
  {
    key: "biaoda",
    label: "表达与共鸣",
    desc: "把日常生活讲成让人又笑又共鸣的故事。真实表达，正成为新的出圈加速器。",
  },
];